import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_CONFIG_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_CONFIG_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_CONFIG_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_CONFIG_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_CONFIG_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_CONFIG_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_CONFIG_MEASUREMENT_ID,
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);

export const requestFirebaseToken = () => {
  getToken(messaging, {
    vapidKey: process.env.REACT_APP_FIREBASE_CONFIG_VAPID_KEY,
  })
    .then((currentToken) => {
      if (currentToken !== localStorage.getItem('firebase_token')) {
        localStorage.setItem('firebase_token', currentToken);
      }
    })
    .catch((err) => {
      if (err && err.status) {
        console.log(
          'An error occurred when requesting to receive the token.',
          err
        );
      } else {
        console.log('An error occurred, Service-Worker not found.', err);
        //window.location.reload();
      }
    });
};

export const requestPermission = () => {
  console.log('Requesting User Permission......');
  Notification.requestPermission().then((permission) => {
    if (permission === 'granted') {
      requestFirebaseToken();
      console.log('Notification User Permission Granted.');
    } else {
      console.log('User Permission Denied.');
    }
  });
};

export const onMessageListener = () =>
  new Promise((resolve) => {
    onMessage(messaging, (payload) => {
      resolve(payload);
    });
  });
